.atm_ar_1bp4okc.atm_ar_1bp4okc{flex-direction:column;}
.atm_40_1fz0aif{border-bottom:1px solid #CED3DA;}
.atm_l8_2xrj94{padding:8px 0px;}
.atm_9s_11p5wf0{display:grid;}
.atm_dz_9syeg7.atm_dz_9syeg7{grid-template-columns:repeat(2, minmax(0, 1fr));}
.atm_cx_1y44olf{gap:4px;}
.atm_d5_18l3jcv.atm_d5_18l3jcv{grid-auto-flow:dense;}
.atm_2zt8x3_stnw88::after{position:absolute;}
.atm_135rde5_1aemfod::after{background:#146EF5;}
.atm_7otamn_exct8b::after{border-radius:16px;}
.atm_d11msr_hv0628::after{border:1.5px solid #ffffff;}
.atm_1054lsl_1fwxnve::after{height:12px;}
.atm_1hh4tvs_1fwxnve::after{width:12px;}
.atm_1ymp90q_i2wt44::after{top:6px;}
.atm_89ifzh_1tcgj5g::after{left:24px;}
.atm_grwvqw_zo7u8::after{z-index:10;}
.atm_1938jqx_1yyfdc7::after{content:'';}
.atm_rxbg8t_14mqujt::after{transition:border-color,opacity ease-in-out 250ms;}
.atm_16mf7wd_1byrjjm.atm_16mf7wd_1byrjjm:hover::after,.atm_16mf7wd_1byrjjm.atm_16mf7wd_1byrjjm:focus::after{border-color:#E7EBEE;}
.atm_40_1w42i3t{border-bottom:1px solid #E7EBEE;}
.atm_l8_9o6drx{padding:8px 16px;}
.atm_j6_66rk6r{min-height:45px;}
.atm_9s_1txwivl{display:flex;}
.atm_fc_1yb4nlp.atm_fc_1yb4nlp{justify-content:space-between;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_gz_ftgil2.atm_gz_ftgil2{margin-left:8px;}
.atm_7l_j1e0tf{color:#CED3DA;}
.atm_1bot3k6_97cm6s svg{transition:color 0.3s ease;}
.atm_oid5br_373i7x svg:first-of-type{color:#5F6771;}
.atm_132ll6i_373i7x svg:nth-of-type(2){color:#5F6771;}
.atm_mk_1if85x1{position:sticky;}
.atm_n3_1tcgj5g{right:24px;}
.atm_9j_73adwj{cursor:default;}
.atm_h_1y6m0gg.atm_h_1y6m0gg{align-items:flex-start;}
.atm_mj_1wugsn5{pointer-events:auto;}
.atm_26_1pec9uq{background:#ffffff;}
.atm_l8_ftgil2{padding:8px;}
.atm_cx_ftgil2{gap:8px;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_70_1y06hsx{box-shadow:0px 4px 8px 3px rgba(0, 33, 82, 0.15),0px 1px 3px 0px rgba(0, 33, 82, 0.30);}
.atm_vy_rdoju8{width:9px;}
.atm_e2_1osqo2v{height:100%;}
.atm_mk_stnw88{position:absolute;}
.atm_n3_idpfg4{right:0;}
.atm_tk_idpfg4{top:0;}
.atm_tr_lxx2j7{transform:translateX(50%) translateZ(1px);}
.atm_tl_glywfm{touch-action:none;}
.atm_uc_m5lnj1{transition:background 0.2s ease;}
.atm_89ifzh_1l7b3ar::after{left:3px;}
.atm_1ymp90q_idpfg4::after{top:0;}
.atm_1hh4tvs_yh40bf::after{width:2px;}
.atm_1054lsl_1osqo2v::after{height:100%;}
.atm_1pbfjna_idpfg4::after{opacity:0;}
.atm_135rde5_6s2ej5::after{background:#424952;}
.atm_rxbg8t_13lo1hf::after{transition:opacity 0.2s ease;}
.atm_1xubhxx_kb7nvz:hover::after{opacity:1;}
.atm_n366lx_kb7nvz:active::after{opacity:1;}
